import colors from 'vuetify/es5/util/colors'
var themes = {
  light: {
    primary: '#00000',
    secondary: '#111111',
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  },
  dark: {
    primary: colors.blue.darken2,
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  }
}
switch (window.env.VUE_APP_AMBIENTE) {
  case 'revo':
    themes = {
      light: {
        primary: '#00000',
        secondary: '#111111',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
    }
    break
}
let background = '/assets/imgs/background.svg'
let logo = '/assets/imgs/logo.svg'

try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/background.svg')
    background = '/assets/imgs/' + localStorage.ambiente + '/background.svg'
  }
} catch { }
try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/logo.svg')
    logo = '/assets/imgs/' + localStorage.ambiente + '/logo.svg'

    var favicon = document.getElementById('custom-favicon')
    favicon.setAttribute('href', '/assets/imgs/' + localStorage.ambiente + '/logo.svg')
  }
} catch { }

export default {
  dark: false,
  options: {
    customProperties: true
  },
  background,
  logo,
  themes: themes
}
